<template>
  <b-card
    border-variant="default"
    class="text-center"
    :no-body="allowCollapse && !isCollapsed && allowCardNoBody"
  >
    <template v-slot:header>
      <div class="float-left">
        <b v-if="title">
          <span v-html="title" />
          <b-badge
            variant="primary"
            pill
            class="fontSize-15 ml-1"
            v-if="showTotals"
            v-text="totalRows"
          />
        </b>
      </div>
      <div class="float-right d-flex">
        <slot name="headerButtons"></slot>

        <!-- start new buttons -->
        <b-overlay
          :show="exportableLoading"
          class="d-inline-block"
          spinner-small
        >
          <b-button
            v-if="exportable && isAdmin(permissionButtons)"
            v-b-tooltip.hover
            class="btn-lightgray ml-2"
            title="خروجی اکسل"
            @click="!exportableLoading && exportData()"
          >
            <i
              :class="{ spinner: exportableLoading }"
              class="fas fa-file-excel fa-lg"
            />
          </b-button>
        </b-overlay>
        <b-button
          v-if="hasRefresh"
          v-b-tooltip.hover
          class="btn-lightgray ml-2"
          title="به‌روز رسانی لیست"
          @click="!pageLoading && fetchData()"
        >
          <i class="fa fa-retweet" />
        </b-button>
        <!-- end new buttons -->

        <b-button
          v-if="allowCollapse && items.length > 0"
          @click="isCollapsed = !isCollapsed"
          variant="success"
          class="float-right"
        >
          <i v-if="isCollapsed" class="fa fa-angle-up" aria-hidden="true"></i>
          <i v-else class="fa fa-angle-down" aria-hidden="true"></i>
        </b-button>

        <div v-if="showBtn" class="btn p-0 ml-2">
          <b-form-select
            size="sm"
            id="view_count_search"
            class="p-1"
            :plain="true"
            :options="viewCountList"
            v-model="viewCount"
            @input="changeViewCount"
          ></b-form-select>
        </div>
        <b-button
          class="btn-lightgray mx-2"
          @click="toggleBtn"
          v-b-tooltip.hover
          :title="$lang.search.settings_tooltip"
        >
          <span key="fa-cog"><i class="fas fa-cog"></i></span>
        </b-button>
      </div>
    </template>
    <b-collapse :visible="searchTableCollapsed" class="over-hidden height">
      <paganationSearch
        v-if="showPaganationTop && filteredData.length && !pageLoading"
        class="mb-3"
        :allowPaginate="allowPaginate"
        :total="totalRows"
        :total_pages="total_pages"
        :perPage="perPage"
        v-model="page"
        @input="paging"
      />
      <b-row class="position-relative min-height-filter">
        <div class="advance_filter" v-show="filter">
          <b-overlay :show="pageLoading" rounded="sm">
            <advanceFilter
              ref="advanceFilter"
              :headers="filterheaders"
              @getFilterItems="getFilterItems"
              @getFilterDate="getFilterDate"
              @closeAdvanceFilter="showFilter"
            />
          </b-overlay>
        </div>
        <b-col cols="12">
          <slot name="loader"></slot>
          <LoadingSpinner :loading="pageLoading" />
          <div class="table-responsive">
            <b-table
              v-if="filteredData"
              v-show="!pageLoading"
              :busy="pageLoading"
              outlined
              hover
              :items="filteredData"
              :fields="headers"
              class="table_main"
              show-empty
              :empty-text="$lang.notRecordExist"
            >
              <template #table-busy>
                <LoadingSpinner :loading="true" />
              </template>
              <template #thead-top="data">
                <b-tr v-if="data">
                  <b-th
                    v-for="(item, index) in itemTopHeader"
                    :key="index"
                    :colspan="item.colspan"
                    :variant="item.variant"
                    class="text-center"
                  >
                    <span class="text-center">{{ item.name }}</span>
                  </b-th>
                </b-tr>
              </template>
              <template v-slot:head()="data" class>
                <div v-if="data.label">
                  <b-dropdown
                    size="xs"
                    variant="bg-transparent"
                    v-if="data.field.filter"
                    toggle-class="text-decoration-none"
                    right
                    no-caret
                    class="float-right d-none d-md-block"
                  >
                    <template v-slot:button-content>
                      <i class="fa fa-filter icon_filter"></i>
                      <span
                        class="badge badg-primary badg-style"
                        v-if="
                          filters[data.field.key]
                            ? filters[data.field.key].length > 0
                            : false
                        "
                        >{{ filters[data.field.key].length }}</span
                      >
                    </template>

                    <b-dropdown-header id="dropdown-header-label">
                      {{ data.label }}
                    </b-dropdown-header>
                    <b-form-checkbox
                      class="m-2"
                      v-model="filterAllSelected[data.field.key]"
                      @change="
                        filterSelectedChange($event, filters, data.field.key)
                      "
                      >{{ $lang.selected }}
                    </b-form-checkbox>
                    <b-form-group
                      label
                      v-if="filters.hasOwnProperty(data.field.key)"
                      class="width-100"
                    >
                      <b-form-checkbox
                        class="m-2"
                        v-for="(option, index) in columnValueList(
                          data.field.key
                        )"
                        v-model="filters[data.field.key]"
                        :key="index"
                        :value="option"
                        name="flavour"
                        >{{ option }}
                      </b-form-checkbox>
                    </b-form-group>
                  </b-dropdown>
                </div>

                <div v-else class="text-center">
                  <b-form-checkbox
                    v-if="!permissionButtons.includes(`view`)"
                    v-model="allSelected"
                    :indeterminate.sync="indeterminate"
                    @change="toggleAll"
                  >
                  </b-form-checkbox>
                </div>
                <div class="text-center white-space">{{ data.label }}</div>
              </template>
              <template v-slot:cell(selected)="data">
                <b-form-group
                  v-if="
                    !permissionButtons.includes(`view`) &&
                    data.item.showCheckBox
                  "
                >
                  <b-form-checkbox
                    :disabled="!showPermissionButton"
                    @change="changeSelected($event, data.item)"
                    v-model="data.item.selected"
                  >
                  </b-form-checkbox>
                </b-form-group>
              </template>
              <template v-slot:cell(value)="data">
                <i
                  class="fa fa-plus text-success"
                  v-if="data.item.value && data.item.value.id == '1'"
                ></i>
                <i v-else class="fa fa-minus text-danger"></i>
              </template>
              <template v-slot:cell(indicator)="data">
                <div
                  v-text="pathOr(null, ['item', 'indicator', 'caption'], data)"
                  class="text-left"
                />
              </template>
              <template v-slot:cell(place_address)="data">
                <div v-html="data.item.place_address"></div>
              </template>
              <template v-slot:cell(related_competency)="data">
                <b-button type="button" @click="getRelatedRow(data.item)">{{
                  data.item.related_competency
                }}</b-button>
              </template>
              <template v-slot:cell(button)="data" style="width: 300px">
                <div
                  v-if="data"
                  class="d-flex align-items-center justify-content-center"
                >
                  <b-tooltip
                    placement="top"
                    target="copy_tooltip"
                    :title="$lang.clone_indicator_ecidance"
                  />
                  <a
                    id="copy_tooltip"
                    class="position-relative mr-3 text-dark cursor-pointer"
                    v-if="
                      data.item && data.item.evidence_count && showDefaultBtn
                    "
                    @click="clone(data.item)"
                  >
                    <i
                      class="fa fa-clone fa-lg cursor-pointer text-secondary"
                      aria-hidden="true"
                    ></i>
                  </a>
                  <a
                    v-if="insert_evidence && showDefaultBtn"
                    class="position-relative text-success cursor-pointer ml-2"
                    @click="chooseEvidance(data.item)"
                    v-b-tooltip.hover
                    :title="$lang.insert_evidence"
                  >
                    <i class="fa fa-plus fa-lg" aria-hidden="true"></i>
                  </a>
                  <a
                    v-if="showRemove && showDefaultBtn"
                    class="position-relative ml-2 text-danger cursor-pointer"
                    @click="removingConfirm(data.item)"
                    v-b-tooltip.hover
                    :title="$lang.remove"
                  >
                    <i
                      class="fas fa-times fa-lg cursor-pointer"
                      aria-hidden="true"
                    ></i>
                  </a>
                  <a
                    v-if="hasAdd && showDefaultBtn"
                    class="position-relative ml-2 text-danger cursor-pointer"
                    @click="editRow(data.item)"
                    v-b-tooltip.hover
                    :title="$lang.search.edit_tooltip"
                  >
                    <i
                      class="fa fa-edit text-success fa-lg cursor-pointer"
                      aria-hidden="true"
                    ></i>
                  </a>

                  <slot name="buttons" :row="data.item" />
                </div>
              </template>
              <template v-slot:cell(audience_fullName)="data">
                <ProfileBoxPopupWrapper
                  :data="data.item.audience"
                  deskTopPopupClass="top-235"
                  nameClass="color-complementary"
                />
              </template>
              <template v-slot:cell(no_begin_research_count)="data">
                <b-button
                  v-b-tooltip.hover
                  title="جهت مشاهده تحقیق‌های بدون اقدام این پرونده کلیک نمائید"
                  variant="secondary"
                  v-text="
                    pathOr(
                      null,
                      ['no_begin_research_count', 'count'],
                      data.item
                    )
                  "
                  @click="countClicked(data.item, 'no_begin_research_count')"
                />
              </template>
              <template v-slot:cell(current_research_count)="data">
                <b-button
                  v-b-tooltip.hover
                  title="جهت مشاهده تحقیق‌های در جریان این پرونده کلیک نمائید"
                  variant="secondary"
                  v-text="
                    pathOr(null, ['current_research_count', 'count'], data.item)
                  "
                  @click="countClicked(data.item, 'current_research_count')"
                />
              </template>
              <template v-slot:cell(semi_completed_research_count)="data">
                <b-button
                  v-b-tooltip.hover
                  title="جهت مشاهده تحقیق‌های اتمام ناقص این پرونده کلیک نمائید"
                  variant="secondary"
                  v-text="
                    pathOr(
                      null,
                      ['semi_completed_research_count', 'count'],
                      data.item
                    )
                  "
                  @click="
                    countClicked(data.item, 'semi_completed_research_count')
                  "
                />
              </template>
              <template v-slot:cell(complete_research_count)="data">
                <b-button
                  v-b-tooltip.hover
                  title="جهت مشاهده تحقیق‌های کامل این پرونده کلیک نمائید"
                  variant="secondary"
                  v-text="
                    pathOr(
                      null,
                      ['complete_research_count', 'count'],
                      data.item
                    )
                  "
                  @click="countClicked(data.item, 'complete_research_count')"
                />
              </template>
              <template v-slot:cell(all_research_count)="data">
                <b-button
                  v-b-tooltip.hover
                  title="جهت مشاهده کل تحقیق‌های این پرونده کلیک نمائید"
                  variant="secondary"
                  v-text="
                    pathOr(null, ['all_research_count', 'count'], data.item)
                  "
                  @click="countClicked(data.item, 'all_research_count')"
                />
              </template>
            </b-table>
            <div v-else>
              <h4 v-if="!pageLoading">{{ dataNotExist || $lang.noData }}</h4>
            </div>
          </div>
          <slot name="footer" />
        </b-col>
      </b-row>

      <paganationSearch
        v-if="filteredData.length > 0 && !pageLoading"
        :allowPaginate="allowPaginate"
        :total="totalRows"
        :total_pages="total_pages"
        :perPage="perPage"
        v-model="page"
        @input="paging"
      />
    </b-collapse>
    <Confirm
      :title="modalTitle"
      :description="message"
      v-model="modalConfirm"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="confirmedRemoveItem"
      @cancel="notConfirmedRemoveItem"
    />
  </b-card>
</template>

<script>
/**
 * @group exerciseDesign
 * این کامپوننت برای ایجاد کردن تمرین تعریف شده است
 */
import { ProfileBoxPopupWrapper } from "@/components/re-design";
import paganationSearch from "@/components/base/paganationSearch";
import Confirm from "@/components/base/confirm";
import advanceFilter from "@/components/base/advanceFilter";
import { isAdmin } from "@/shared/utils";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr, includes } from "ramda";

export default {
  components: {
    Confirm,
    paganationSearch,
    advanceFilter,
    LoadingSpinner,
    ProfileBoxPopupWrapper,
  },
  props: {
    defaultViewCount: {
      type: Number,
      default: null,
    },
    dataNotExist: {
      type: String,
      default: "",
    },
    showDefaultBtn: {
      type: Boolean,
      default: true,
    },
    filterheaders: {
      type: Array,
      default: () => [],
    },
    showTotals: {
      type: Boolean,
      default: true,
    },
    allowPaginate: {
      type: Boolean,
      default: true,
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
    allowCardNoBody: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    showPaganationTop: {
      type: Boolean,
      default: false,
    },
    insert_evidence: {
      type: Boolean,
      default: true,
    },
    hasAdd: {
      type: Boolean,
      default: false,
    },
    showRemove: {
      type: Boolean,
      default: true,
    },
    allowCollapse: {
      type: Boolean,
      default: false,
    },
    perPage: {
      type: [Number, String],
      default: 1,
    },
    total_pages: {
      type: [Number, String],
      default: 0,
    },
    totalRows: {
      type: [Number, String],
      default: 0,
    },
    items: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: [Array, Object],
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => [],
    },
    url: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    changePage: {
      type: Function,
      default: () => [],
    },
    remove_item: {
      type: Function,
      default: () => [],
    },
    showPermissionButton: {
      type: Boolean,
      default: true,
    },
    permissionButtons: {
      type: Array,
      default: () => [],
    },
    itemTopHeader: {
      type: Array,
      default: () => [],
    },
    showNewCustomButton: {
      type: Boolean,
      default: false,
    },
    exportable: {
      type: Boolean,
      default: false,
    },
    resourceKey: {
      type: String,
      default: null,
    },
    paramsData: {
      type: Object,
      default: () => {},
    },
    hasRefresh: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      page: this.currentPage,
      id: this.$route.params.id,
      viewCountList: [5, 15, 25, 50, 100, 500, 1000],
      viewCount: this.defaultViewCount,
      showBtn: false,
      filter: false,
      SelectAllOrNot: false,
      allSelected: true,
      filterAllSelected: {
        competency: true,
        indicator: true,
        exercise: true,
      },
      indeterminate: true,
      addModal: false,
      isCollapsed: false,
      selected: [],

      keyFilter: null,
      filterdata: [],
      modalConfirm: false,
      modalTitle: "",
      message: "",
      removingItem: {},
      paramsPage: {},
      exportableLoading: false,
    };
  },
  computed: {
    /**
     * @vuese
     *    فیلتر کردن داده‌ها استفاده می شود
     *  @arg  بدون پارامتر
     */
    filteredData() {
      if (this.filters && this.filters.length > 0) {
        return (
          this.items &&
          this.items.length > 0 &&
          this.items.filter((d) => {
            return Object.keys(this.filters).every((key) => {
              return (
                this.filters[key].length < 1 ||
                this.filters[key].includes(d[key])
              );
            });
          })
        );
      } else {
        return this.items;
      }
    },
    searchTableCollapsed() {
      if (this.allowCollapse && !this.isCollapsed) return false;
      else return true;
    },
  },
  watch: {
    currentPage(newValue, oldValue) {
      this.page = newValue;
    },
    filters(e) {
      if (this.items && this.items.length > 0) {
        Object.keys(this.filters).map((key) => {
          let data = [...new Set(this.items.map((x) => x[key]))];
          if (data.length > 0 && data.filter((x) => x != null).length > 0) {
            this.filters[key] = data;
          }
        });
      }
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    toggleBtn() {
      this.showBtn = !this.showBtn;
    },
    changeViewCount(item) {
      this.$emit("changeViewCount", item);
    },
    editRow(item) {
      this.$emit("editRow", item);
    },
    removingConfirm(item) {
      this.removingItem = item;
      this.modalConfirm = true;
      this.message = this.$lang.are_you_sure_to_remove_item.replace(
        "{item}",
        item.indicator || item.exercise
      );
      this.modalTitle = this.$lang.remove_item;
    },
    confirmedRemoveItem() {
      if (this.removingItem) {
        this.remove_item(this.removingItem).finally(() => {
          this.removingItem = null;
          this.message = "";
          this.modalConfirm = false;
        });
      }
    },
    notConfirmedRemoveItem() {
      this.removingItem = null;
      this.message = "";
      this.modalConfirm = false;
    },
    getRelatedRow(item) {
      this.$emit("getRelatedRow", item);
    },
    getStyle(color) {
      return {
        color: color,
      };
    },
    clone(item) {
      this.$emit("clone", item);
    },
    filterSelectedChange(event, item, key) {
      this.filterAllSelected[key] = event;
      let dataFilter = {
        ...this.filters,
      };
      if (!this.filterAllSelected[key]) {
        this.filters[key] = [];
      } else {
        const data = [...this.items];
        const distinct = [...new Set(data.map((d) => d[key]))];
        if (
          distinct.length > 0 &&
          distinct.filter((x) => x != null).length > 0
        ) {
          this.filters[key] = distinct;
        }
      }
    },
    /**
     * @vuese
     *    فیلتر کردن عنوان‌ها و ایتم‌هایی که دارند استفاده می شود
     *  @arg  val کلیدی است برای این که داده مربوط به هر عنوان را شناسایی کیم
     */
    columnValueList(val) {
      const data = [...this.items];
      const distinct = [...new Set(data.map((d) => d[val]))];
      return distinct;
    },
    /**
     * @vuese
     *    دکمه فیلتر برای تغییر حالت دیایویی‌ها
     *  @arg  بدون پارامتر
     */
    showFilter() {
      this.filter = !this.filter;
    },
    /**
     * @vuese
     *   چک باکس‌های درون هر سطر اضافه و خذف شدن برای ارایه که قرار ارسال شود
     *  @arg  row  هر سطر
     */
    changeSelected(event, row) {
      this.$emit("changeSelected", row, event);
    },
    /**
     * @vuese
     *  برای تیک زدن تمام چک باکس‌ها
     *  @arg  checked هر سطر تیک خورده یا نه
     */
    toggleAll(checked) {
      if (checked) {
        this.selected = this.items.slice();
        this.selected.map((x) => (x.selected = true));
        this.$emit("selectedaAll", this.selected, checked);
      } else {
        this.selected.map((x) => (x.selected = false));
        this.$emit("selectedaAll", this.selected, checked);
        this.selected = [];
      }
    },
    extractValue(item, v) {
      if (item[v] && typeof item[v] === "object") {
        if ("jalali" in item[v]) {
          return item[v].jalali;
        } else if ("caption" in item[v]) {
          return item[v]["caption"];
        } else if ("name" in item[v]) {
          return item[v]["name"];
        } else if ("view_label" in item[v]) {
          return item[v].view_label ? item[v].view_label : "";
        }
      } else {
        return item[v];
      }
    },
    chooseEvidance(item) {
      this.$emit("chooseEvidance", item);
    },
    paging(page) {
      this.allSelected = false;
      this.page = page;
      this.changePage(page);
    },
    getFilterItems(value, key) {
      if (
        (typeof value == "string" || typeof value == "number") &&
        value !== ""
      ) {
        this.paramsPage[key] = value;
      } else if (typeof value == "object" && value.length > 0) {
        this.paramsPage[key] = value;
      } else {
        delete this.paramsPage[key];
      }
      this.paramsPage["page"] = 1;
      this.page = 1;
      this.$emit("getFilterItems", this.paramsPage);
    },
    getFilterDate(key, type, value_from, value_to) {
      if (value_from) {
        this.paramsPage[key] = [type, value_from];
      } else if (value_to && value_from) {
        this.paramsPage[key] = [type, value_from, value_to];
      } else {
        delete this.paramsPage[key];
      }
      this.paramsPage["page"] = 1;
      this.page = 1;
      this.$emit("getFilterItems", this.paramsPage);
    },
    allFilterRemove() {
      this.$refs.advanceFilter.allFilterRemove();
    },
    fetchData() {
      this.$emit("fetchData");
    },
    async exportData() {
      if (!this.exportable) return;
      try {
        this.exportableLoading = true;
        const url =
          this.$config.api_url +
          this.$config.resources.exportData.replace("{0}", this.resourceKey);
        const payload = {
          filters: this.paramsData,
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.exportableLoading = false;
      }
    },
    countClicked(item, countKey) {
      this.$emit("countClicked", item, countKey);
    },
  },
};
</script>
<style>
.table thead th {
  vertical-align: inherit !important;
  outline: 0;
  border-left: 1px solid lightgray;
}

.table th,
.table td {
  vertical-align: inherit !important;
  outline: 0;
}

.height {
  min-height: 10vh;
  width: 100%;
}

/* .dropdown-toggle {
    padding: 0 !important;
  } */

.width-100 {
  min-width: 300px;
  width: 100%;
  max-height: 300px;
  overflow-x: hidden;
}

/* .dropdown-menu{
  right:0 !important;
  left: auto  !important;
} */
/* .table_main {
    height: 100% !important;
  } */

.white-space {
  white-space: nowrap;
}

.icon_filter {
  position: absolute;
  bottom: 0px;
  left: -11px;
}

.btn:focus {
  box-shadow: 0 0 0 0 rgba(32, 168, 216, 0.25) !important;
}

.badg-style {
  position: absolute !important;
  top: -4px !important;
  right: -10px !important;
  color: white;
  background-color: rgb(0, 172, 232);
  width: 20px;
  overflow: hidden;
}

.badg-main {
  position: absolute !important;
  top: -4px !important;
  left: -10px !important;
  color: white;
  background-color: #f86c6b;
  width: 20px;
  overflow: hidden;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
